import { Text, Code, Box, Group, ThemeIcon } from "@mantine/core";
import { ArrowRight } from "lucide-react";
import { ProcessStep } from "../../services/logService";

export function NormalizationResultContent({ log }: { log: ProcessStep }) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const details = (log.details as any) || {};
  const originalName = details.originalName;
  const normalizedName = details.normalizedName;

  return (
    <Box mt={4}>
      <Text
        size="xs"
        c={log.status === "error" ? "red" : "inherit"}
        style={{ whiteSpace: "pre-line" }}
      >
        {log.description}
      </Text>

      {(originalName || normalizedName) && (
        <Box
          mt="xs"
          p="xs"
          bg="var(--mantine-color-default)"
          style={{
            borderRadius: "6px",
            border: "1px solid var(--mantine-color-default-border)",
          }}
        >
          <Group align="center" gap="sm">
            <Box style={{ flex: 1, minWidth: 0 }}>
              <Text size="10px" c="dimmed" mb={2}>
                OCR抽出文字列
              </Text>
              <Code
                block
                style={{
                  fontSize: "11px",
                  padding: "4px 8px",
                  minHeight: "28px",
                  display: "flex",
                  alignItems: "center",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {originalName || "(未検出)"}
              </Code>
            </Box>

            <ThemeIcon variant="transparent" c="dimmed" mt={12}>
              <ArrowRight size={16} />
            </ThemeIcon>

            <Box style={{ flex: 1, minWidth: 0 }}>
              <Text size="10px" c="dimmed" mb={2}>
                特定された取引先
              </Text>
              <Box
                h={28}
                px="xs"
                bg="var(--mantine-color-blue-light)"
                style={{
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  color: "var(--mantine-color-blue-light-color)",
                }}
              >
                <Text
                  size="xs"
                  fw={700}
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {normalizedName || "不明"}
                </Text>
              </Box>
            </Box>
          </Group>
        </Box>
      )}
    </Box>
  );
}
